import { SharedPermissionService } from '@agroone-front/shared'
import { UserPermissions } from '@agroone/entities'
import { Injectable } from '@angular/core'
import { OFFLINE_PERMISSIONS_CONFIG } from '../../shared/user/config/offline-permissions-config'

@Injectable({
  providedIn: 'root',
})
export class PermissionService extends SharedPermissionService {
  protected getOfflinePermissions(): UserPermissions[] {
    return OFFLINE_PERMISSIONS_CONFIG
  }
}
